var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row head_block",staticStyle:{"margin":"0px","padding":"0px","height":"74px"}},[_vm._t("header")],2)}
var staticRenderFns = []

export { render, staticRenderFns }